Ext.define('SA.view.ConstrainedSizeResolver', {
    singleton: true,

    getConstrainedSize({containerSize, contentSize, contentWidthPlusScrollbarWidth, contentHeightPlusScrollbarHeight}) {
        var contentWiderThanContainer = contentSize.width > containerSize.width,
            contentTallerThanContainer = contentSize.height > containerSize.height,
            useContainerSize = (contentTallerThanContainer && contentWiderThanContainer)
                || (contentWiderThanContainer && (contentHeightPlusScrollbarHeight > containerSize.height))
                || (contentTallerThanContainer && (contentWidthPlusScrollbarWidth > containerSize.width));

        if (useContainerSize) {
            return containerSize;
        }
        else if (contentWiderThanContainer) {
            return {width: containerSize.width, height: contentHeightPlusScrollbarHeight};
        }
        else if (contentTallerThanContainer) {
            return {width: contentWidthPlusScrollbarWidth, height: containerSize.height};
        }

        return contentSize;
    }
});